import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';
import { FlowManagementService } from '../services/flow-management.service';
import { Flow } from '../obj/Flow';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MsalHelperService } from '../services/msal-helper.service';
import { AuthenticationResult } from '@azure/msal-browser';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-flow-editor',
    templateUrl: './flow.editor.component.html',
    styleUrls: ['./flow.editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FlowEditorComponent implements OnInit, OnDestroy {

  @Input() flow: Flow;
  public flowDesignerUrl: SafeResourceUrl;
  private result: AuthenticationResult;
  private subscription = new Subscription();
  private sdk = null;

  constructor(private flowManagementService: FlowManagementService, private msalHelperService: MsalHelperService, private notificationService: NotificationService, private sanitizer: DomSanitizer) {
    const { MsFlowSdk } = <any>window;

    this.sdk = new MsFlowSdk({
      hostName:'https://make.powerautomate.com',
      locale:'en-US'
    }); 
    this.subscription.add(
      this.msalHelperService.getAccessTokenSilent$(['https://service.flow.microsoft.com//Flows.Manage.All']).subscribe((result)=>{
        this.result = result; //?.secret;
      })  
    );

  }

  ngOnInit(): void {

    var widget = this.sdk.renderWidget('flowEdit', {
      container: 'flowDiv',
      flowName: this.flow.flowName,
      environmentId: this.flow.environment,
      flowsSettings: {

      },
      // templatesSettings: {},
      // approvalCenterSettings: {},
      widgetStyleSettings: {}
    });

    widget.listen("GET_ACCESS_TOKEN", (requestParam, widgetDoneCallback) => {
      widgetDoneCallback(null, {
          token: this.result?.accessToken  
      });
    });

    this.flowDesignerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://make.powerautomate.com/manage/environments/${this.flow.environment}/flows/${this.flow.flowName}`)
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
